import { useState } from "react";
import { useUser } from "../context/UserContext";
import { apiPost } from "../api/apiConfig";

const Login = ({ onShowRegister, onShowCambioClave, onShowRestablecerClave, onLoginSuccess }) => {
  const { setUserData } = useUser();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const result = await apiPost("/auth/login", {
        email: formData.username,
        password: formData.password,
      });

      if (result.success) {
        setMessage("Login exitoso!");
        console.log('Login result:', result);
        console.log('User data from login:', result.user);
        console.log('ejec_sist_factoring field:', result.user?.ejec_sist_factoring);
        // Asegurar email en sesión (algunos logins Cognito no lo traen en user).
        const loginEmail = String(formData.username || '').trim();
        const userPayload = {
          ...(result.user || {}),
          email: result.user?.email || result.user?.mail || loginEmail,
          mail: result.user?.mail || result.user?.email || loginEmail,
        };
        setUserData(userPayload);
        onLoginSuccess(userPayload);
      } else {
        setMessage(result.message || "Usuario o contraseña incorrectos");
      }
    } catch (error) {
      console.error("Error en login:", error);
      setMessage(error.message || "Error de conexión");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="left-side">
        <div className="logo-container">
        </div>
        <div className="bottom-text">
          <h1>Módulo de Gestión Comercial</h1>
          <p>Gerencia Comercial</p>
        </div>
      </div>

      <div className="right-side">
        <div className="login-form-container">
          <div className="login-header">
            <div className="mgc-title">
              <img src="/img/logo.png" alt="Logo" className="logo-img" />
              <span className="mgc-text">
                <strong>MGC</strong>Interfactor
              </span>
            </div>
            <p className="login-subtitle">Ingresa tu usuario y contraseña</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                className="login-input"
                placeholder="Usuario"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                required
                disabled={isLoading}
              />
            </div>

            <div className="input-group">
              <input
                type="password"
                className="login-input"
                placeholder="Contraseña"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                disabled={isLoading}
              />
            </div>

            <div className="checkbox-group">
              <input
                type="checkbox"
                id="remember_me"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleInputChange}
                disabled={isLoading}
              />
              <label htmlFor="remember_me">Recuérdame</label>
            </div>

            {message && (
              <div
                className={`message ${
                  message.includes("exitoso") ? "success" : "error"
                }`}
              >
                {message}
              </div>
            )}

            <button type="submit" className="login-button" disabled={isLoading}>
              {isLoading ? "Ingresando..." : "Ingresar"}
            </button>

            <div className="footer-text">
              <button
                onClick={onShowCambioClave}
                className="link-button"
                type="button"
              >
                ¿Quires cambiar tu clave? Clic acá
              </button>
              <br />
              <button
                onClick={onShowRestablecerClave}
                className="link-button"
                type="button"
              >
                Restablecer contraseña
              </button>
              <br />
              © Interfactor | 2024 | V 5.0.2
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
